export const SITE_ORIGIN = 'https://treet.fi';

export const withTrailingSlash = (path: string): string => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (normalized === '/') return '/';

  return normalized.endsWith('/') ? normalized : `${normalized}/`;
};

export const canonicalUrl = (path: string): string => `${SITE_ORIGIN}${withTrailingSlash(path)}`;
